import Vue, { VueConstructor } from 'vue'

type ContagemDoContador = (valor: string) => number

interface VTextFieldInterno {
  internalValue?: string | null
  contagemDoContador?: ContagemDoContador
}

// No Vuetify 1.5 o VTextField registrado é um wrapper funcional (escolhe entre VTextField e VTextarea) e o componente
// de verdade fica em options.$_wrapperFor, que não está nos tipos do Vue. Estender o wrapper não tem efeito.
interface ComponenteRegistradoDoVuetify {
  options: { '$_wrapperFor'?: VueConstructor }
}

let textFieldComContador: VueConstructor | undefined

const getVTextFieldDoVuetify = (): VueConstructor => {
  const registrado = Vue.component('VTextField')

  return (registrado as unknown as ComponenteRegistradoDoVuetify).options.$_wrapperFor || registrado
}

// O Vuetify 1.5 não tem a prop counter-value (só no 2.x): o contador sempre conta o texto inteiro exibido.
// Esta extensão recebe a função de contagem pela prop contagem-do-contador. É criada no primeiro uso para não depender
// da ordem do Vue.use(Vuetify).
const getTextFieldComContador = (): VueConstructor => {
  if (!textFieldComContador) {
    textFieldComContador = getVTextFieldDoVuetify().extend({
      name: 'v-text-field-com-contador',
      props: {
        contagemDoContador: Function,
      },
      computed: {
        counterValue(this: VTextFieldInterno): number {
          const valor = String(this.internalValue || '')

          if (!this.contagemDoContador) {
            return valor.length
          }

          return this.contagemDoContador(valor)
        },
      },
    })
  }

  return textFieldComContador
}

export default getTextFieldComContador
